import { render, staticRenderFns } from "./blu-future-form.vue?vue&type=template&id=36ca56d0&scoped=true"
import script from "./blu-future-form.vue?vue&type=script&lang=js"
export * from "./blu-future-form.vue?vue&type=script&lang=js"
import style0 from "./blu-future-form.vue?vue&type=style&index=0&id=36ca56d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca56d0",
  null
  
)

export default component.exports